import React from "react";
import DataTable from "../../../components/DataTable";
const dataJson = [
  {
    id: "78df5s5",
    sn: "01",
    date: "15/03/2022",
    amount: "$785",
    remarks: "754",
    txnNumber: "fg7fg8dg",
  },
  {
    id: "fd7fsf8",
    sn: "02",
    date: "19/03/2022",
    amount: "$779",
    remarks: "47",
    txnNumber: "dfsf5sd5f",
  },
  {
    id: "4875",
    sn: "03",
    date: "25/03/2022",
    amount: "$874",
    remarks: "59",
    txnNumber: "fsf4sf",
  },
];

const columns = [
  { id: "sn", label: "S.N", minWidth: 20 },
  { id: "date", label: "Date", minWidth: 100 },
  {
    id: "amount",
    label: "Amount",
    minWidth: 80,
  },
  {
    id: "remarks",
    label: "Remarks",
    minWidth: 80,
  },
  {
    id: "txnNumber",
    label: "Txn Number",
    minWidth: 100,
  },
];

function createData(sn, date, amount, remarks, txnNumber) {
  return {
    sn,
    date,
    amount,
    remarks,
    txnNumber,
  };
}

const rows = dataJson.map((d) =>
  createData(d.sn, d.date, d.amount, d.remarks, d.txnNumber)
);

const RoiBonusTable = () => {
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default RoiBonusTable;
